import { render, staticRenderFns } from "./subtract_amount.vue?vue&type=template&id=3a5ba990&scoped=true&"
import script from "./subtract_amount.vue?vue&type=script&lang=js&"
export * from "./subtract_amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ba990",
  null
  
)

export default component.exports